import { BeanControllerLike } from './beanControllerLike.ts';

export class BeanStyleBase extends BeanControllerLike {}
